import { API_HOST } from './appConstants'

export const BASE_API = `${API_HOST}/api`

const contentTypesTree = {
  // athleticTeams: ['ilustration'],
  // bios: ['ilustration', 'photo'],
  quotes: ['ilustration', 'photo'],
  featured_videos: ['previewImage'],
  general_contents: ['previewImage', 'ilustration'],
  general_events: ['ilustration'],
  // posters: ['ilustration', 'previewImage'],
  // customContents: ['image'],
}

// const featuredContentParams = () => {
//   let query = ''
//   Object.entries(contentTypesTree).forEach(
//     ([key, value]) =>
//       (query = query.concat(
//         `&populate[${key}][filters][featuredContent][$eq]=true&populate[${key}][populate]=${value}`
//       ))
//   )
//   return query
// }
const featuredContentParams = () => {
  let query = ''
  Object.entries(contentTypesTree).forEach(([key, value]) => {
    const populateFields = value.map((field, index) => `populate[${key}][populate][${index}]=${field}`).join('&')
    query = query.concat(`&populate[${key}][filters][featuredContent][$eq]=true&${populateFields}`)
  })
  return query
}

const screenContentTypesParams = () => {
  let query = ''
  Object.entries(contentTypesTree).forEach(
    ([key, value]) => (query = query.concat(`&populate[${key}][fields]=documentId`))
  )
  return query
}

/**
 * SCREENS SERVICES
 */
export const GET_SCREENS = `${BASE_API}/screens`
export const GET_ACTIVE_SCREENS = `${BASE_API}/screens?filters[activeScreen]=true`
export const GET_SCREEN_ZONE = screenId => `${BASE_API}/zones?filters[screens][screenId]=${screenId}`
export const GET_SCREEN_CONTENT_TYPES = screenId => `${GET_SCREEN_ZONE(screenId)}${screenContentTypesParams()}`

/**
 * CONTENT SERVICES
 */
export const GET_LIST = (contentType, currPage = 1, zone) =>
  `${BASE_API}/${contentType}?filters[zones][documentId]=${zone}&pagination[pageSize]=50&pagination[page]=${currPage}&populate=*`
export const GET_EVENTS_LIST = (currPage = 1, zone) =>
  `${BASE_API}/zones/${zone}/events?pageSize=10&page=${currPage}&populate=*`
export const GET_EVENTS_TYPE_LIST = (contentType, currPage = 1, zone) =>
  `${BASE_API}/${contentType}?filters[zones][documentId]=${zone}&pagination[pageSize]=10&pagination[page]=${currPage}&sort[0]=date%3Adesc&sort[1]=time%3Adesc&populate=*`
export const GET_FEATURED_CONTENT = screenId => `${GET_SCREEN_ZONE(screenId)}${featuredContentParams()}`
export const GET_UPCOMING_EVENTS = zone => `${BASE_API}/zones/${zone}/upcomingEvents`
export const GET_BY_ID = (contentType, documentId) => `${BASE_API}/${contentType}/${documentId}?populate=*`
export const GET_SEARCH = (zone, query) => `${BASE_API}/zones/${zone}/search/${query}`
